import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { ClassificationCategoriesService } from '../../../../app.retailer.common/modules/categories/classification-categories.service';
import { CategoriesSelectorService } from '../../categories/categoriesSelector.service';
import { CreateNfcOperationRequest, PlaceListShortModel } from '../../core';
import { IRetailerRootScope } from '../../core/models';
import { NfcRetailerStickersService } from '../nfc-retailer-stickers.service';

class NfcWizard {
    static $inject = ['$scope', '$translate', '$rootScope', '$timeout', 'categoriesSelectorService',
        'classificationCategoriesService', 'nfcRetailerStickersService', 'notificationService', '$state'];

    model = {
        wizardNextStepButtonDisabled: false,
        assignNewStickers: true,
        step: 1,
        selectedLocations: <PlaceListShortModel[]> [],
        isAllLocationsSelected: <boolean> false,
        selectedProductsAndCategories:  <any[]> [],
        isAllProductsSelected: <boolean> false,
        isAllCategoriesSelected: <boolean> false,
        firstStickerNumber: <string> '',
        assignType: <any> 1,
    };

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        public $rootScope: IRetailerRootScope,
        private $timeout: ng.ITimeoutService,
        protected categoriesSelectorService: CategoriesSelectorService,
        public classificationCategoriesService: ClassificationCategoriesService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService,
        public $state: StateService
    ) {
        $scope.$watch(() => this.model.step, () => {
            this.changeWizardNextButtonEnabledIfNeed();
        });

        $scope.$watch(() => this.model.selectedLocations, () => {
            this.changeWizardNextButtonEnabledIfNeed();
        });

        $scope.$watch(() => this.model.firstStickerNumber, () => {
            this.changeWizardNextButtonEnabledIfNeed();
        });

        $scope.$watchCollection(() => this.model.selectedProductsAndCategories, () => {
            this.changeWizardNextButtonEnabledIfNeed();
        });
    }

    changeWizardNextButtonEnabledIfNeed() {
        if (this.model.step === 1 && this.model.selectedLocations.length === 0) {
            this.model.wizardNextStepButtonDisabled = true;
            return;
        }

        if (this.model.step === 2 && this.productAndCategoriesIsInvalid()) {
            this.model.wizardNextStepButtonDisabled = true;
            return;
        }

        if (this.model.step === 3 && this.model.firstStickerNumber.length < 1) {
            this.model.wizardNextStepButtonDisabled = true;
            return;
        }
        this.model.wizardNextStepButtonDisabled = false;
    }

    resetAssign = () => {
        this.model = null;
        this.$state.go('app.nfcs.active');
    }

    createOperation = () => {
        let locationIDs = this.model.selectedLocations.map(x => x.ID);
        let productIDs = this.model.selectedProductsAndCategories.filter(x => x.hasOwnProperty('ID')).map(x => x.ID);
        let categoriesIDs = this.model.selectedProductsAndCategories.filter(x => x.hasOwnProperty('CategoryID')).map(x => x.CategoryID);
        let assignType = this.model.assignType;
        let firstStickerNumber = this.model.firstStickerNumber;

        let request : CreateNfcOperationRequest = {
            PlaceIDs : locationIDs,
            ProductIDs: productIDs,
            CategoryIDs: categoriesIDs,
            AssignType: assignType,
            FirstStickerNumber: firstStickerNumber
        };

        this.nfcRetailerStickersService.createOperation(request)
            .then(response => {
                if (!response.HasErrors) {
                    this.notificationService.showSuccessMessage();
                    this.$state.go('app.nfcs.history');
                    return;
                }

                if (response.StickerNumberError) {
                    this.notificationService.showErrorMessage(response.StickerNumberError);
                }

                if (response.InvalidProducts && response.InvalidProducts.length > 0) {
                    let message = 'Products ' + response.InvalidProducts.map(x => x.Title).join(', ') + ' are invalid';
                    this.notificationService.showErrorMessage(message);
                }

                if (response.InvalidPlaces && response.InvalidPlaces.length > 0) {
                    let message = 'Locations ' + response.InvalidPlaces.map(x => x.Title).join(', ') + ' are invalid';
                    this.notificationService.showErrorMessage(message);
                }
            })
            .catch(error => this.notificationService.showErrorMessage(error));
    }

    productAndCategoriesIsInvalid = () => {
        if (this.model.selectedProductsAndCategories.length === 0) {
            return true;
        }

        const categories = this.model.selectedProductsAndCategories.filter(x => x.hasOwnProperty('CategoryID')).map(x => x.CategoryID);
        const productsWithSameCategory =
            this.model.selectedProductsAndCategories.filter(x => x.hasOwnProperty('ID') && categories.some(r => r === x.ClassificationCategoryID))
                                                    .map(x => x.Title);
        if (productsWithSameCategory && productsWithSameCategory.length > 0) {
            let invalidProductsText = productsWithSameCategory.join(', ');

            let notificationText = productsWithSameCategory.length === 1
                ? this.$translate.instant('invalid_product_with_same_category', { product: invalidProductsText })
                : this.$translate.instant('invalid_products_with_same_category', { products: invalidProductsText });

            this.notificationService.showErrorMessage(notificationText);
            this.$timeout(() => this.notificationService.clearAll(), 5000);
            return true;
        }

        this.notificationService.clearAll();
        return false;
    }
}

angular.module('naut').component('nfcWizard', {
    template: require('./nfc-wizard.component.html'),
    controller: NfcWizard,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/wizard/nfc-wizard.component.ts